import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiResponse } from 'src/app/helpers/interfaces/api-response';
import { Project } from 'src/app/model/project/project';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class SubmitExecutedProjectControllerRequestService {
  private static BASE_URL = '/projects/submitExecutedProject';
  private readonly post: <T>(
    path: string,
    body: Project,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserializer = (res) => res as Project;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      SubmitExecutedProjectControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public submitExecutedProject(
    project: Project
  ): Observable<Project | ApiResponse<Project>> {
    return this.post('', project, this.deserializer);
  }
}
